import { render, staticRenderFns } from "./HeaderMenuItem.vue?vue&type=template&id=3e794b7a&"
import script from "./HeaderMenuItem.vue?vue&type=script&lang=js&"
export * from "./HeaderMenuItem.vue?vue&type=script&lang=js&"
import style0 from "./HeaderMenuItem.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports